// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"426":"a75beba9","779":"0dc8585d"}[chunkId] + ".chunk.css";
};